import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ExpandedCardModal } from '../expanded-card/expanded-card.modal';
import { TranslationsService } from './../../../../translations/translations.service';

@Component({
  selector: 'csi-widget-table-card',
  templateUrl: './widget-table-card.component.html',
  styleUrls: ['./widget-table-card.component.scss']
})
export class WidgetTableCardComponent implements OnChanges {
  @Input() card: any;

  columnDefs = [];
  activeTabIndex = 0;
  public readonly translocoFileKey = 'dashboard.';
  constructor(private dialog: MatDialog, public translationsService: TranslationsService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['card']) {
      this.syncColumnDefs();
    }
  }

  get hasTabs(): boolean {
    return !!(this.card.tabs && this.card.tabs.length > 0);
  }

  get activeTab(): any {
    return this.hasTabs ? this.card.tabs[this.activeTabIndex] : null;
  }

  get activeContent(): any[] {
    return this.hasTabs ? this.activeTab.content : this.card.content;
  }

  get activeData(): any[] {
    return this.hasTabs ? this.activeTab.data : this.card.data;
  }

  get activeClickable(): any {
    return this.hasTabs ? this.activeTab.clickable : this.card.clickable;
  }

  onTabChange(index: number) {
    this.activeTabIndex = index;
    this.syncColumnDefs();
  }

  private syncColumnDefs() {
    this.columnDefs = (this.activeContent || []).map(col => col.heading);
  }

  public expandCard() {
    const cardToExpand = this.hasTabs
      ? {
          ...this.card,
          title: this.activeTab.label,
          content: this.activeContent,
          data: this.activeData,
          clickable: this.activeClickable
        }
      : this.card;
    ExpandedCardModal.open(this.dialog, cardToExpand);
  }
}
